export default __webpack_public_path__ + "static/media/src_jquery_desktop_3.3ad68bea.jpg";